// components/Home.js
import React, { useEffect, useState } from 'react';
import { Box, Button, Card, Grid, Typography } from '@mui/material';
import { LayoutDashboard } from '../../layouts/DasboardLayout';
import TypographyTitle from '../../components/Titles/TypographyTitle';
import toast from 'react-hot-toast';
import { API_URL } from '../../config';
import MensajeDialog from '../../components/Dialogs/MensajeDialog';
import DialogEditarConfiguracion from '../../sections/Admin/Configuracion/DialogCrear';

const CardConfiguracion = ({ nombre, valor }) => {
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 5,
        padding: 2,
        marginBottom: '1rem',
        width: '100%',
        height: '100%',
      }}
    >
      <Typography
        variant='h6'
        sx={{
          color: 'primary.gold',
        }}
      >
        {nombre}
      </Typography>
      <Typography
        variant='h4'
        sx={{
          color: 'primary.black',
          fontWeight: 'bold',
        }}
      >
        {valor}
      </Typography>
    </Card>
  );
}

const Home = () => {
  const [configuraciones, setConfiguraciones] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
  }

  const handleActualizarConfiguracion = async (data) => {
    try {
      setLoading(true);

      const newData = [
        {
          id: configuraciones.find(c => c.nombre === 'Municipio').id,
          valor: data.municipio,
        },
        {
          id: configuraciones.find(c => c.nombre === 'Signos').id,
          valor: data.casillasSignosVitales,
        },
        {
          id: configuraciones.find(c => c.nombre === 'Triage').id,
          valor: data.casillasTriage,
        },
        {
          id: configuraciones.find(c => c.nombre === 'Fecha Evento').id,
          valor: data.fecha,
        }
      ]
      const response = await fetch(`${API_URL}/configuracion`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          data: newData,
        }),
      });
      const result = await response.json();
      if (result.error) {
        toast.error(result.message);
      } else {
        toast.success(isEdit ? 'Configuración actualizada correctamente' : 'Configuración creada correctamente');
      }
      setLoading(false);

      //Recargar la pagina despues de 2 segundos
      // setTimeout(() => {
      //   window.location.reload();
      // }, 2000);
    } catch (error) {
      setLoading(false);
      toast.error('Error al actualizar la configuración');
    }
  }

  const getConfiguraciones = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/configuracion`);
      const data = await response.json();
      setConfiguraciones(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Error al obtener las configuraciones');
    }
  }

  const getMnunicipios = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/municipio`);
      const data = await response.json();
      setMunicipios(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Error al obtener los municipios');
    }
  }

  useEffect(() => {
    getConfiguraciones();
    getMnunicipios();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'left',
        height: '100%',
        width: '100%',
        padding: '2rem',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '2rem',
        }}
      >
        <TypographyTitle
          variant='h4'
          marginBottom='1rem'
        >
          Configuración Actual
        </TypographyTitle>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button
            variant='outlined'
            color='primary'
            onClick={() => {
              setIsEdit(true);
              handleOpenDialog();
            }}
            sx={{
              marginRight: '1rem',
            }}
          >
            Actualizar
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => {
              setIsEdit(false);
              handleOpenDialog();
            }}
          >
            Crear brigada
          </Button>
        </Box>
      </Box>
      {
        loading &&
        <Typography
          variant='h5'
          sx={{
            color: 'primary.black',
          }}
        >
          Cargando...
        </Typography>
      }
      {
        !loading && configuraciones &&
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
            sm={4}
          >
            <CardConfiguracion
              nombre='Municipio'
              valor={municipios?.find(m => m.id === configuraciones.find(c => c.nombre === 'Municipio')?.valor)?.nombre}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={4}
          >
            <CardConfiguracion
              nombre='Casillas Signos Vitales'
              valor={configuraciones.find(c => c.nombre === 'Signos')?.valor}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
          >
            <CardConfiguracion
              nombre='Casillas Triage'
              valor={configuraciones.find(c => c.nombre === 'Triage')?.valor}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
          >
            <CardConfiguracion
              nombre='Fecha de la brigada'
              valor={configuraciones.find(c => c.nombre === 'Fecha Evento')?.valor}
            />
          </Grid>
        </Grid>
      }
      <DialogEditarConfiguracion
        open={openDialog}
        handleClose={handleCloseDialog}
        handleCrear={handleActualizarConfiguracion}
        municipios={municipios}
        configuraciones={configuraciones}
        isEdit={isEdit}
      />

      <MensajeDialog
        open={false}
        handleClose={() => { }}
        data={{}}
      />
    </Box >
  );
};

const HomeAdministrador = () => {
  return (
    <LayoutDashboard>
      <Home />
    </LayoutDashboard>
  );
}

export default HomeAdministrador;
